// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


import App from './App'
import router from './router'
import store from './vuex/store' // 引入store

import ElementUI from 'element-ui'
import Icon from '@/components/Icon';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/style.css'
import './assets/style/common.css'
import './assets/style/rewrite.css'
import "babel-polyfill";
Vue.use(ElementUI, { size: 'small' });
// Vue.use(ElementUI);
import elTableInfiniteScroll from 'el-table-infinite-scroll';
Vue.use(elTableInfiniteScroll);
Vue.component('icon', Icon);
import 'signalr'

Vue.config.productionTip = false

import BzToolBar from '@/components/BzToolBar';
Vue.component('BzToolBar', BzToolBar);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
Date.prototype.Format = function (fmt) { //author: meizz 
  var o = {
    "M+": this.getMonth() + 1, //�·� 
    "d+": this.getDate(), //�� 
    "h+": this.getHours(), //Сʱ 
    "m+": this.getMinutes(), //�� 
    "s+": this.getSeconds(), //�� 
    "q+": Math.floor((this.getMonth() + 3) / 3), //���� 
    "S": this.getMilliseconds() //���� 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

  return fmt;
};


// WEBPACK FOOTER //
// ./src/main.js